export default __webpack_public_path__ + "a3246d29b40a8b0da142caea1bc84974.woff";